module.exports = __webpack_public_path__ + "static/media/bkg_story_2.46cd930a.jpg";